export const LINKEDIN = "https://www.linkedin.com/company/altri-consultancy/";
export const YOUTUBE = "https://www.youtube.com/@altriconsultancy";
export const INSTAGRAM = "https://www.instagram.com/altri.consultancy/";
export const FACEBOOK = "https://www.facebook.com/altri.consultancys";
export const EMAIL = "mailto:info@altriconsultancy.com";
export const TEL = "tel:0031653254977";
